import { action } from 'typesafe-actions';
// Show Toast
export const SHOW_TOAST = 'Show toast';
export const showToast = (toast, position) => action(SHOW_TOAST, { toast, position });
// Render Toast
export const RENDER_TOAST = 'Render toast';
export const renderToast = (id) => action(RENDER_TOAST, { id });
// Hide Toast
export const HIDE_TOAST = 'Hide toast';
export const hideToast = (id) => action(HIDE_TOAST, { id });
// Hide All Toasts
export const HIDE_ALL_TOASTS = 'Hide all toasts';
export const hideAllToasts = () => action(HIDE_ALL_TOASTS);
//# sourceMappingURL=actions.js.map